module.exports = __webpack_public_path__ + "cc90712c09dac75f024ba7070da2954e.png";